import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { LandingServiceService } from 'src/app/Services/landing-service.service';
import * as myGlobals from "../../../app.component";

@Component({
  selector: 'app-directory-body',
  templateUrl: './directory-body.component.html',
  styleUrls: ['./directory-body.component.scss']
})
export class DirectoryBodyComponent implements OnInit {

  displayedColumns: string[] = ['sno', 'name', 'designation', 'phone', 'extension', 'email'];
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private landingService: LandingServiceService,
    private toastr: ToastrService) {
  }

  baseBackUrl = myGlobals.baseUrl;
  directories: any[];

  ngOnInit(): void {
    this.landingService.getAllDirectoryHomePage().subscribe(response => this.handleResponse(response));
  }

  handleResponse(data) {
    if(data['type']=='Success') {
      this.setdirectory(data);
    } else {
      this.toastr.error(data['Error'])
    }
  }

  setdirectory(data) {
    // this.dataSource = new MatTableDataSource(data['Directory']);
    // this.dataSource.paginator =this.paginator;
    // this.dataSource.sort = this.sort;
    this.directories = data['Directory'];
  }

}
